import styled, { css } from 'styled-components';

interface IDurationProps {
  isExperience?: boolean;
}

interface IndividualItemProps {
  isSelected: boolean;
}

export const Container = styled.div<IndividualItemProps>`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 5rem;
  width: 100%;
  margin: 10px 0px;
  background-color: var(--white);
  border: 1px solid var(--divider);
  text-align: left;

  ${props =>
    props.isSelected &&
    css`
      border: 2px solid var(--green);
    `}
`;

export const ItemPrice = styled.div`
  min-width: 33%;
  font-weight: 700;
  color: var(--primary);
  text-align: end;
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 40%;
  justify-content: space-around;

  div {
    display: flex;
    flex-flow: column;
    align-items: center;
  }
`;

export const Duration = styled.div<IDurationProps>`
  display: flex;
  ${({ isExperience }) =>
    isExperience &&
    css`
      flex-direction: column;
    `}
  align-items: center;

  > div {
    width: 70px;
    display: flex;

    > input {
      width: 100%;
    }

    svg {
      margin-right: 9px;
    }
  }
`;
